import * as tslib_1 from "tslib";
import { ChangeDetectorRef, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MaintenancesApi } from '@api/maintenances/maintenances.api';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { isNil } from 'lodash';
import { debounceTime, first } from 'rxjs/operators';
import { sentry } from 'sentry';
import { AuthenticationService } from '../../../../../../core/authentication/authentication.service';
import english from '../../../../i18n/en.json';
import spanish from '../../../../i18n/es.json';
import portuguese from '../../../../i18n/pt.json';
var TabProductsComponent = /** @class */ (function () {
    function TabProductsComponent(data, progressBar, fuseTranslationLoaderService, maintenancesApiService, changeDetectorRef, authenticationService) {
        this.data = data;
        this.progressBar = progressBar;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.maintenancesApiService = maintenancesApiService;
        this.changeDetectorRef = changeDetectorRef;
        this.authenticationService = authenticationService;
        this.orderBy = 'name_asc';
        this.products = null;
        this.filteredProducts = null;
        this.paginationLimit = 0;
        this.paginationOffset = 0;
        this.loadingProducts = true;
        this.searchInputValue = new FormControl();
        this.maintenance = this.data.maintenance;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    TabProductsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadProducts()];
                    case 1:
                        _a.sent();
                        this.searchInputValue
                            .valueChanges
                            .pipe(debounceTime(500))
                            .subscribe(function () {
                            _this.paginationOffset = 0;
                            _this.loadProducts();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    TabProductsComponent.prototype.toNextPage = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.paginationOffset += 5;
                        return [4 /*yield*/, this.loadProducts()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TabProductsComponent.prototype.toPreviousPage = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.paginationOffset -= 5;
                        return [4 /*yield*/, this.loadProducts()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TabProductsComponent.prototype.orderByName = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.orderBy === 'name_asc') {
                            this.orderBy = 'name_desc';
                        }
                        else {
                            this.orderBy = 'name_asc';
                        }
                        return [4 /*yield*/, this.loadProducts()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TabProductsComponent.prototype.showLoading = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var isProgressBarVisible;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loadingProducts = true;
                        return [4 /*yield*/, this.progressBar.visible
                                .pipe(first())
                                .toPromise()];
                    case 1:
                        isProgressBarVisible = _a.sent();
                        if (!isProgressBarVisible) {
                            this.progressBar.show();
                            this.changeDetectorRef.markForCheck();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TabProductsComponent.prototype.hideLoading = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var isProgressBarVisible;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loadingProducts = false;
                        return [4 /*yield*/, this.progressBar.visible
                                .pipe(first())
                                .toPromise()];
                    case 1:
                        isProgressBarVisible = _a.sent();
                        if (isProgressBarVisible) {
                            this.progressBar.hide();
                            this.changeDetectorRef.markForCheck();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TabProductsComponent.prototype.loadProducts = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var variables, _a, hasInputValue, _b, _c, err_1;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.showLoading()];
                    case 1:
                        _d.sent();
                        if (!isNil(this.data.maintenance.company && this.data.maintenance.company.id)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.hideLoading()];
                    case 2:
                        _d.sent();
                        return [2 /*return*/];
                    case 3:
                        variables = {
                            limit: 5,
                            offset: this.paginationOffset,
                            maintenanceId: this.data.maintenance.id,
                            orderBy: this.orderBy,
                            where: {
                                type: 'product'
                            }
                        };
                        _d.label = 4;
                    case 4:
                        _d.trys.push([4, 9, 10, 11]);
                        _a = this;
                        return [4 /*yield*/, this.maintenancesApiService
                                .searchMaintenanceProductsServices(variables)
                                .toPromise()];
                    case 5:
                        _a.products = _d.sent();
                        if (this.products.totalCount === null) {
                            sentry.captureMessage('Error loading products', {
                                extra: {
                                    variables: JSON.stringify(variables)
                                },
                                user: {
                                    id: this.authenticationService.user.id,
                                    email: this.authenticationService.user.email,
                                    username: this.authenticationService.user.name,
                                }
                            });
                        }
                        hasInputValue = Boolean(this.searchInputValue.value);
                        if (hasInputValue) {
                            variables.where = {
                                name_contains: this.searchInputValue.value
                            };
                        }
                        _b = this;
                        if (!hasInputValue) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.maintenancesApiService.searchMaintenanceProductsServices(variables).toPromise()];
                    case 6:
                        _c = _d.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        _c = this.products;
                        _d.label = 8;
                    case 8:
                        _b.filteredProducts = _c;
                        this.paginationLimit = this.filteredProducts && this.filteredProducts.totalCount <= 5
                            ? this.filteredProducts.totalCount
                            : 5;
                        return [3 /*break*/, 11];
                    case 9:
                        err_1 = _d.sent();
                        sentry.captureException(err_1, {
                            extra: {
                                variables: JSON.stringify(variables)
                            },
                            user: {
                                id: this.authenticationService.user.id,
                                email: this.authenticationService.user.email,
                                username: this.authenticationService.user.name,
                            }
                        });
                        return [3 /*break*/, 11];
                    case 10:
                        this.hideLoading();
                        return [7 /*endfinally*/];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    return TabProductsComponent;
}());
export { TabProductsComponent };
